import { useState } from 'react';
import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import { OrderDateLargeDividend } from '@/lib/apollo/types/gen/graphql';
import { setLargeDividendAlertCookie } from '@/lib/verification';

import { Container, Text, TextLink } from './style';

interface LargeDividendAlertProps {
  largeDividend: OrderDateLargeDividend;
}

const LargeDividendAlert: React.FC<LargeDividendAlertProps> = ({
  largeDividend,
}) => {
  const [hidden, setHidden] = useState<boolean>(false);
  const buttonEvent = () => {
    setLargeDividendAlertCookie('Confirmed', largeDividend.refundAmount);
    setHidden(true);
  };

  return (
    <Container hidden={hidden}>
      <Text>
        高額の払戻金については、一時所得として確定申告が必要となる場合がございます。
        <br />
        <TextLink
          href="https://support.dmm.com/keirin/article/31129"
          target="_blank"
        >
          こちら
        </TextLink>
        の内容をご確認の上、所定の手続きをお願いいたします。
      </Text>
      <Button
        bgColor="primary"
        size="m"
        radius="m"
        fontWeight="bold"
        height="56px"
        width={['100%', '320px', '320px', '320px']}
        onClick={() => {
          buttonEvent();
        }}
      >
        確認しました
      </Button>
    </Container>
  );
};

export default LargeDividendAlert;
